import { boxShadow, label, orange, secondary } from 'styles'
import { hexToRGBA } from 'utils'

import { makeStyles } from '@mui/styles'

export default makeStyles({
  disabled: {
    '&&.MuiMenuItem-root': {
      backgroundColor: hexToRGBA(label, 0.1),
    },
  },
  divider: {
    '&&.MuiDivider-root': {
      marginBottom: '0',
      marginTop: '0',
    },
  },
  iconDone: {
    marginLeft: '0.5rem',
  },
  iconMore: {
    '&&': {
      color: secondary,
      marginRight: '0.9rem',
      padding: '1rem',
    },
    '& > svg': {
      fontSize: '2rem',
    },
  },
  menu: {
    '&&': {
      boxShadow,
    },
  },
  menuList: {
    '&&': {
      paddingBottom: '0',
      paddingTop: '0',
    },
  },
  menuItem: {
    '&&': {
      fontSize: '1.3rem',
      padding: '1rem 3rem 1rem 1.5rem',
      minWidth: '150px',
    },
  },
  selected: {
    '&&': {
      color: orange,
      fontWeight: '600',
    },
  },
})
